import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type { IApiRefreshLiveStreamResponseBody } from '../LiveStreamsApi.types';
import { useApi } from '~/lib/api/useApi';
import { liveStreamQueryKeyFactory } from './useLiveStreamQuery';
import { liveStreamsQueryKeyFactory } from './useLiveStreamsQuery';

export type IUseRefreshLiveStreamMutationValues = {
  appId: string;
  liveStreamId: string;
};

export const useRefreshLiveStreamsMutation = (): UseMutationResult<
  IApiRefreshLiveStreamResponseBody,
  unknown,
  IUseRefreshLiveStreamMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) =>
      api.liveStreams.refresh(values.appId, values.liveStreamId),
    onSuccess: async (refreshedLiveStream, values) => {
      queryClient.setQueryData(
        liveStreamQueryKeyFactory({
          ...values,
          liveStreamId: refreshedLiveStream._id,
        })!,
        refreshedLiveStream,
      );
      await queryClient.invalidateQueries({
        queryKey: liveStreamsQueryKeyFactory(),
      });
    },
  });
};
